/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/show_pin_medium'
export default icon
